import React from 'react';
import { useSettings } from '../../../hooks/admin/useSettings';
import { SettingsCard } from './SettingsCard';

export function EmailSettings() {
  const { settings, updateSettings, isLoading } = useSettings('email');

  return (
    <SettingsCard
      title="Email Settings"
      description="Configure email notifications and templates"
      isLoading={isLoading}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white mb-2">
            SMTP Host
          </label>
          <input
            type="text"
            value={settings?.smtpHost || ''}
            onChange={(e) => updateSettings({ smtpHost: e.target.value })}
            className="input w-full"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              SMTP Port
            </label>
            <input
              type="number"
              value={settings?.smtpPort || ''}
              onChange={(e) => updateSettings({ smtpPort: e.target.value })}
              className="input w-full"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-2">
              SMTP Security
            </label>
            <select
              value={settings?.smtpSecurity || 'tls'}
              onChange={(e) => updateSettings({ smtpSecurity: e.target.value })}
              className="input w-full"
            >
              <option value="tls">TLS</option>
              <option value="ssl">SSL</option>
              <option value="none">None</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            SMTP Username
          </label>
          <input
            type="text"
            value={settings?.smtpUsername || ''}
            onChange={(e) => updateSettings({ smtpUsername: e.target.value })}
            className="input w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            SMTP Password
          </label>
          <input
            type="password"
            value={settings?.smtpPassword || ''}
            onChange={(e) => updateSettings({ smtpPassword: e.target.value })}
            className="input w-full"
          />
        </div>
      </div>
    </SettingsCard>
  );
}